var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenBookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 44.332,
    viewBox: "0 0 62 44.332",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_671",
    "data-name": "Group 671",
    transform: "translate(-449 -525.973)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_514",
    "data-name": "Group 514",
    transform: "translate(449 525.973)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    d: "M73.488,23.032V10.754c-.469-1.319-1.522-1.6-2.763-1.572-.829.018-.831.005-.831.839q0,6.008,0,12.017a13.68,13.68,0,0,1,3.592.994",
    transform: "translate(-16.417 -2.157)",
    fill: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    "data-name": "Path 302",
    d: "M48.74,51.738a18.224,18.224,0,0,0-3.652,1.907,9.885,9.885,0,0,0-1.917,1.577.667.667,0,0,0,.547.03,34.965,34.965,0,0,1,6.552-.838,15.132,15.132,0,0,1-1.53-2.676",
    transform: "translate(-10.141 -12.153)",
    fill: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    d: "M29.1,25.231q0,7.821,0,15.642c0,.18.084.439-.077.522-.222.113-.343-.16-.478-.292a22.112,22.112,0,0,0-11.878-5.759,40.888,40.888,0,0,0-5.859-.548A2.05,2.05,0,0,1,8.77,32.669q-.007-15.28,0-30.56A2,2,0,0,1,10.781.015C16.242.083,21.394,1.16,25.72,4.79a15.352,15.352,0,0,1,3.066,3.578,2.488,2.488,0,0,1,.321,1.388q-.008,7.738,0,15.475",
    transform: "translate(-2.059 -0.004)",
    fill: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M46.515,33.964c-.327-7.311,6.109-13.586,13.144-14.183q0-8.726,0-17.452A2.1,2.1,0,0,0,57.311,0a28.7,28.7,0,0,0-7.3,1,17.34,17.34,0,0,0-10.1,6.939,3.27,3.27,0,0,0-.6,1.921c.015,5.1.008,10.205.008,15.308q0,7.849,0,15.7c0,.18-.084.44.077.522.223.113.344-.159.477-.292a19.407,19.407,0,0,1,5.473-3.768c.5-.239,1.013-.454,1.526-.653a15.747,15.747,0,0,1-.363-2.715",
    transform: "translate(-9.232 0)",
    fill: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M24.053,45.24c-.2.136-.389.034-.578-.008a38.861,38.861,0,0,0-8.776-.856A52.339,52.339,0,0,0,2.857,45.758,2.255,2.255,0,0,1,0,43.452C.05,32.839.026,22.227.027,11.614A2.153,2.153,0,0,1,2.416,9.192c1.467-.03,1.238-.061,1.239,1.2Q3.665,22.5,3.66,34.6a5.116,5.116,0,0,0,2.823,4.818,5.23,5.23,0,0,0,2.468.572,29.149,29.149,0,0,1,6.982.9,18.543,18.543,0,0,1,7.811,3.969c.119.106.288.176.308.378",
    transform: "translate(0 -2.157)",
    fill: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M53.008,40.6A10.722,10.722,0,1,1,63.7,51.359h-.009A10.686,10.686,0,0,1,53.008,40.664V40.6m9.59,5.148a2.54,2.54,0,0,0,2.091-.995c.632-.731,1.272-1.454,1.907-2.184,1.11-1.271,2.226-2.536,3.326-3.816a1.557,1.557,0,0,0,.01-1.989,1.524,1.524,0,0,0-1.884-.311,2.421,2.421,0,0,0-.612.562c-1.293,1.48-2.581,2.966-3.888,4.438-.7.781-1.308.761-2.031,0-.531-.558-1.062-1.117-1.626-1.64a1.486,1.486,0,0,0-2.1.011l-.023.024a1.453,1.453,0,0,0-.039,2.055c.019.02.039.04.059.058q1.464,1.523,2.959,3.018a2.335,2.335,0,0,0,1.849.771",
    transform: "translate(-12.451 -7.027)",
    fill: "#3b993a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenBookIcon);
export default __webpack_public_path__ + "static/media/open_book_icon.9b81734bd3fb4e520ad02d77f2136bb6.svg";
export { ForwardRef as ReactComponent };